// searchable-select.component.ts
import { Component } from '@angular/core';
import { ROUTES } from '@core/constants';
import { LoadStrategy } from '@core/enums';
import { AsyncSelectorOptions } from '@core/types';

@Component({
  selector: 'app-cp-async-selector',
  template: ``,
  styles: [``],
})
export class CpAsyncSelectorComponent {
  ROUTES = ROUTES;
  options: AsyncSelectorOptions = {
    loadStrategy: LoadStrategy.EAGER_ON_INIT,
  };
}
